"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconCtaModule = _interopRequireDefault(require("./IconCta.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function IconCta(_ref) {
  var label = _ref.label,
    href = _ref.href,
    _ref$newTab = _ref.newTab,
    newTab = _ref$newTab === void 0 ? false : _ref$newTab,
    dataTracking = _ref.dataTracking;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _IconCtaModule["default"].iconCta,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
      "data-testid": "icon-cta",
      href: href,
      target: newTab ? '_blank' : undefined,
      rel: newTab ? 'noopener noreferrer' : undefined,
      "data-event": dataTracking.eventType,
      "data-component": dataTracking.componentName,
      "data-section": dataTracking.section,
      "data-location": dataTracking.linkLocation,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _IconCtaModule["default"].label,
        children: label
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "32",
          height: "32",
          rx: "6",
          fill: '#102B2B'
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M16.5617 24.0009H14.4404L21.6899 16.7513L8.50098 16.7513L8.50098 15.2513L21.69 15.2513L14.4405 8.00183L16.5618 8.00183L24.5613 16.0013L16.5617 24.0009Z",
          fill: '#DFFF7B'
        })]
      })]
    })
  });
}
var _default = exports["default"] = IconCta;